import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '@roku-web-ui/rds-theme';

import styles from './eventsScrollLoading.module.scss';

export const EventsScrollLoading = () => (
  <Box className={styles.loadingContainer}>
    <CircularProgress sx={{ color: colors.purple[500] }} />
  </Box>
);
